import { Group, Stack } from '@mantine/core';
import { useProcessAnalysisStore } from '../../../../../store/process-analysis-store/process-analysis-store';
import { inkLight } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';
import { useInfoItems } from './side-section.hooks';

export const SideSectionInfo = () => {
  const selectedDataPoint = useProcessAnalysisStore((state) => state.selectedDataPoint);
  const infoItems = useInfoItems();

  if (!selectedDataPoint || infoItems.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Text size="small" weight="medium">
        {selectedDataPoint.date}
      </Text>
      <Stack gap={8}>
        {infoItems.map((item) => (
          <Group key={item.label} justify="space-between">
            <Group gap={4}>
              <Icon name={item.icon} size={16} color={item.color} />
              <Text size="small" color={inkLight}>
                {item.label}
              </Text>
            </Group>
            <Text size="small">{item.value}</Text>
          </Group>
        ))}
      </Stack>
    </Stack>
  );
};
